import { render, staticRenderFns } from "./ArticleRow.vue?vue&type=template&id=4b8cb469&scoped=true&"
import script from "./ArticleRow.vue?vue&type=script&lang=js&"
export * from "./ArticleRow.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRow.vue?vue&type=style&index=0&id=4b8cb469&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8cb469",
  null
  
)

export default component.exports